export const PAGE_TYPES = {
  BODY: 'body',
  HEALTH: 'health',
  MIND: 'mind',
  LIFE: 'life',
  SKIN: 'skin',
  ABOUT: 'about',
  POLICY: 'policy',
  TERMS: 'terms',
};

export const DNA_ROUTE_TYPES = {
  HOME: 'dna-home',
  LOGIN: 'dna-login',
  ELEMENT: 'dna-element',
  PILLAR: 'dna-element',
  GCI_REPORT: 'dna-gci-report',
  HOUSEHOLD: 'dna-household',
  PROFILE: 'dna-profile',
  INTAKE_TEMPLATE: 'dna-intake-template',
  PREFERENCE: 'dna-preference',
  SETTINGS: 'dna-settings',
  KITS: 'dna-kits',
  PURCHASE_KIT: 'dna-purchase-kit',
  REGISTER_KIT: 'dna-register-kit',
  LEGAL_CONSENT_CENTER: 'dna-legal-consent-center',
  TASKS: 'dna-tasks',
  PRACTITIONER: 'dna-practitioner',
  PRACTITIONER_DASHBOARD: 'dna-practitioner-dashboard',
  PRACTITIONER_PATIENTS: 'dna-practitioner-patients',
  PRACTITIONER_PATIENT_DETAIL: 'dna-practitioner-patient-detail',
  PRACTITIONER_PATIENT_SUMMARY: 'dna-practitioner-patient-summary',
  PRACTITIONER_PATIENT_DASHBOARD: 'dna-practitioner-patient-dashboard',
  PRACTITIONER_PATIENT_GCI: 'dna-practitioner-patient-gci',
  PRACTITIONER_PATIENT_PROTOCOLS: 'dna-practitioner-patient-protocols',
  PRACTITIONER_PATIENT_MEALS: 'dna-practitioner-patient-meals',
  PRACTITIONER_PATIENT_PROGRESS: 'dna-practitioner-patient-progress',
  PRACTITIONER_PATIENT_SOURCES: 'dna-practitioner-patient-sources',
  PRACTITIONER_PATIENT_NOTES: 'dna-practitioner-patient-notes',
  PRACTITIONER_PATIENT_ASSISTANT: 'dna-practitioner-patient-assistant',
  PRACTITIONER_MEALS_REVIEW: 'dna-practitioner-meals-review',
  PRACTITIONER_TASKS: 'dna-practitioner-tasks',
  PRACTITIONER_REVIEWS: 'dna-practitioner-reviews',
  PRACTITIONER_LABS: 'dna-practitioner-labs',
  PRACTITIONER_PROTOCOLS: 'dna-practitioner-protocols',
  PRACTITIONER_ASSISTANT: 'dna-practitioner-assistant',
  PRACTITIONER_SETTINGS: 'dna-practitioner-settings',
  CUSTOM_SUPPLEMENT: 'dna-custom-supplement',
  ORDER_TESTS: 'dna-order-tests',
  PROTOCOL: 'dna-protocol',
  PROGRESS: 'dna-progress',
  SOURCES: 'dna-sources',
  MEALS: 'dna-meals',
  ADMIN: 'dna-admin',
  ADMIN_SOURCE_REVIEW: 'dna-admin-source-review',
  ADMIN_GENETICS_AUDIT: 'dna-admin-genetics-audit',
  ADMIN_INTAKE_AUDIT: 'dna-admin-intake-audit',
  ADMIN_TRACE_AUDIT: 'dna-admin-trace-audit',
  ADMIN_OPERATOR_PROJECTIONS: 'dna-admin-operator-projections',
  ADMIN_SYSTEM_VISIBILITY: 'dna-admin-system-visibility',
  ADMIN_CALCULATED_PROFILES: 'dna-admin-calculated-profiles',
  ADMIN_FEATURE_READINESS: 'dna-admin-feature-readiness',
  ADMIN_ASSIGNMENT_READINESS: 'dna-admin-assignment-readiness',
  ADMIN_ORDER_LINKAGE: 'dna-admin-order-linkage',
  ADMIN_HOUSEHOLD_READINESS: 'dna-admin-household-readiness',
  ADMIN_PREMIUM_ACCESS_TESTING: 'dna-admin-premium-access-testing',
};

export const INTERNAL_ROUTES = [
  { path: '/', label: 'Home' },
  { path: '/health', label: 'Health', type: PAGE_TYPES.HEALTH },
  { path: '/mind', label: 'Mind', type: PAGE_TYPES.MIND },
  { path: '/body', label: 'Body', type: PAGE_TYPES.BODY },
  { path: '/life', label: 'Life', type: PAGE_TYPES.LIFE },
  { path: '/skin', label: 'Skin', type: PAGE_TYPES.SKIN },
  { path: '/about', label: 'About', type: PAGE_TYPES.ABOUT },
  { path: '/policy', label: 'Privacy Policy', type: PAGE_TYPES.POLICY },
  { path: '/terms', label: 'Terms & Conditions', type: PAGE_TYPES.TERMS },
];

export const CONTENT_PAGE_ROUTES = INTERNAL_ROUTES.filter((route) => route.type);

export const NAV_ROUTES = INTERNAL_ROUTES.filter(
  (route) => route.label && route.path !== '/policy' && route.path !== '/terms',
);

export const BANNERLESS_PAGE_TYPES = new Set([
  PAGE_TYPES.ABOUT,
  PAGE_TYPES.POLICY,
  PAGE_TYPES.TERMS,
]);

export const DNA_LEGACY_APP_BASE_PATH = '/dna';
export const DNA_APP_BASE_PATH = '/life/dna';

export function getCanonicalDnaPathFromLegacyPath(
  pathname = DNA_LEGACY_APP_BASE_PATH,
  search = '',
  hash = '',
) {
  const normalizedPathname = String(pathname || DNA_LEGACY_APP_BASE_PATH);
  const legacySuffix = normalizedPathname.startsWith(`${DNA_LEGACY_APP_BASE_PATH}/`)
    ? normalizedPathname.slice(DNA_LEGACY_APP_BASE_PATH.length)
    : '';

  return `${DNA_APP_BASE_PATH}${legacySuffix}${search || ''}${hash || ''}`;
}

export function getDnaLandingPathForRole(role = '') {
  const normalizedRole = String(role || '').trim().toUpperCase();

  if (normalizedRole === 'ADMIN') {
    return `${DNA_APP_BASE_PATH}/admin`;
  }

  if (normalizedRole === 'PRACTITIONER') {
    return `${DNA_APP_BASE_PATH}/practitioner`;
  }

  return DNA_APP_BASE_PATH;
}

function parseBooleanEnvFlag(value) {
  return ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());
}

export const ENABLE_HOUSEHOLD_UI = parseBooleanEnvFlag(process.env.REACT_APP_ENABLE_HOUSEHOLD_UI);
export const ENABLE_PRACTITIONER_UI = parseBooleanEnvFlag(process.env.REACT_APP_ENABLE_PRACTITIONER_UI);

export const DNA_APP_ROUTES = [
  { path: DNA_APP_BASE_PATH, label: 'DNA Dashboard', type: DNA_ROUTE_TYPES.HOME },
  { path: `${DNA_APP_BASE_PATH}/login`, label: 'DNA Login', type: DNA_ROUTE_TYPES.LOGIN },
  { path: `${DNA_APP_BASE_PATH}/elements/:element`, label: 'DNA Element', type: DNA_ROUTE_TYPES.ELEMENT },
  { path: `${DNA_APP_BASE_PATH}/pillars/:pillar`, label: 'DNA Element', type: DNA_ROUTE_TYPES.ELEMENT },
  { path: `${DNA_APP_BASE_PATH}/gci-report`, label: 'DNA GCI Report', type: DNA_ROUTE_TYPES.GCI_REPORT },
  { path: `${DNA_APP_BASE_PATH}/profile`, label: 'DNA Patient Profile', type: DNA_ROUTE_TYPES.PROFILE },
  { path: `${DNA_APP_BASE_PATH}/sources/intake/:element`, label: 'DNA Intake Template', type: DNA_ROUTE_TYPES.INTAKE_TEMPLATE },
  { path: `${DNA_APP_BASE_PATH}/preferences`, label: 'DNA Personal Inputs', type: DNA_ROUTE_TYPES.PREFERENCE },
  { path: `${DNA_APP_BASE_PATH}/settings`, label: 'DNA Settings', type: DNA_ROUTE_TYPES.SETTINGS },
  { path: `${DNA_APP_BASE_PATH}/kits`, label: 'DNA Kits', type: DNA_ROUTE_TYPES.KITS },
  { path: `${DNA_APP_BASE_PATH}/purchase-kit`, label: 'Purchase DNA Kit', type: DNA_ROUTE_TYPES.PURCHASE_KIT },
  { path: `${DNA_APP_BASE_PATH}/register-kit`, label: 'Register DNA Kit', type: DNA_ROUTE_TYPES.REGISTER_KIT },
  { path: `${DNA_APP_BASE_PATH}/legal-consent`, label: 'DNA Legal & Consent Center', type: DNA_ROUTE_TYPES.LEGAL_CONSENT_CENTER },
  { path: `${DNA_APP_BASE_PATH}/tasks`, label: 'DNA Daily Tasks', type: DNA_ROUTE_TYPES.TASKS },
  { path: `${DNA_APP_BASE_PATH}/progress`, label: 'DNA Progress', type: DNA_ROUTE_TYPES.PROGRESS },
  { path: `${DNA_APP_BASE_PATH}/sources`, label: 'DNA Sources', type: DNA_ROUTE_TYPES.SOURCES },
  { path: `${DNA_APP_BASE_PATH}/meals`, label: 'DNA Meals', type: DNA_ROUTE_TYPES.MEALS },
  { path: `${DNA_APP_BASE_PATH}/household`, label: 'DNA Household', type: DNA_ROUTE_TYPES.HOUSEHOLD },
  { path: `${DNA_APP_BASE_PATH}/practitioner`, label: 'DNA Practitioner', type: DNA_ROUTE_TYPES.PRACTITIONER },
  { path: `${DNA_APP_BASE_PATH}/practitioner/dashboard`, label: 'DNA Practitioner Dashboard', type: DNA_ROUTE_TYPES.PRACTITIONER_DASHBOARD },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients`, label: 'DNA Practitioner Patients', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENTS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId`, label: 'DNA Practitioner Patient Detail', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_DETAIL },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/summary`, label: 'DNA Practitioner Patient Summary', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_SUMMARY },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/dashboard`, label: 'DNA Practitioner Patient Dashboard', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_DASHBOARD },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/gci`, label: 'DNA Practitioner Patient GCI', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_GCI },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/protocols`, label: 'DNA Practitioner Patient Protocols', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_PROTOCOLS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/meals`, label: 'DNA Practitioner Patient Meals', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_MEALS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/progress`, label: 'DNA Practitioner Patient Progress', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_PROGRESS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/sources`, label: 'DNA Practitioner Patient Sources', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_SOURCES },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/notes`, label: 'DNA Practitioner Patient Notes', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_NOTES },
  { path: `${DNA_APP_BASE_PATH}/practitioner/patients/:patientId/assistant`, label: 'DNA Practitioner Patient Assistant', type: DNA_ROUTE_TYPES.PRACTITIONER_PATIENT_ASSISTANT },
  { path: `${DNA_APP_BASE_PATH}/practitioner/meals-review`, label: 'DNA Practitioner Meals', type: DNA_ROUTE_TYPES.PRACTITIONER_MEALS_REVIEW },
  { path: `${DNA_APP_BASE_PATH}/practitioner/tasks`, label: 'DNA Practitioner Tasks', type: DNA_ROUTE_TYPES.PRACTITIONER_TASKS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/reviews`, label: 'DNA Practitioner Reviews', type: DNA_ROUTE_TYPES.PRACTITIONER_REVIEWS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/labs`, label: 'DNA Practitioner Labs', type: DNA_ROUTE_TYPES.PRACTITIONER_LABS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/protocols`, label: 'DNA Practitioner Protocols', type: DNA_ROUTE_TYPES.PRACTITIONER_PROTOCOLS },
  { path: `${DNA_APP_BASE_PATH}/practitioner/assistant`, label: 'DNA Practitioner Assistant', type: DNA_ROUTE_TYPES.PRACTITIONER_ASSISTANT },
  { path: `${DNA_APP_BASE_PATH}/practitioner/settings`, label: 'DNA Practitioner Settings', type: DNA_ROUTE_TYPES.PRACTITIONER_SETTINGS },
  { path: `${DNA_APP_BASE_PATH}/admin`, label: 'DNA Admin', type: DNA_ROUTE_TYPES.ADMIN },
  { path: `${DNA_APP_BASE_PATH}/admin/source-review`, label: 'DNA Admin Source Review', type: DNA_ROUTE_TYPES.ADMIN_SOURCE_REVIEW },
  { path: `${DNA_APP_BASE_PATH}/admin/genetics-audit`, label: 'DNA Admin Genetics Audit', type: DNA_ROUTE_TYPES.ADMIN_GENETICS_AUDIT },
  { path: `${DNA_APP_BASE_PATH}/admin/intake-audit`, label: 'DNA Admin Intake Audit', type: DNA_ROUTE_TYPES.ADMIN_INTAKE_AUDIT },
  { path: `${DNA_APP_BASE_PATH}/admin/trace-audit`, label: 'DNA Admin Trace Audit', type: DNA_ROUTE_TYPES.ADMIN_TRACE_AUDIT },
  { path: `${DNA_APP_BASE_PATH}/admin/operator-projections`, label: 'DNA Admin Operator Projections', type: DNA_ROUTE_TYPES.ADMIN_OPERATOR_PROJECTIONS },
  { path: `${DNA_APP_BASE_PATH}/admin/system-visibility`, label: 'DNA Admin System Visibility', type: DNA_ROUTE_TYPES.ADMIN_SYSTEM_VISIBILITY },
  { path: `${DNA_APP_BASE_PATH}/admin/system-visibility/calculated-profiles`, label: 'DNA Admin Calculated Profiles', type: DNA_ROUTE_TYPES.ADMIN_CALCULATED_PROFILES },
  { path: `${DNA_APP_BASE_PATH}/admin/feature-readiness`, label: 'DNA Admin Feature Readiness', type: DNA_ROUTE_TYPES.ADMIN_FEATURE_READINESS },
  { path: `${DNA_APP_BASE_PATH}/admin/assignment-readiness`, label: 'DNA Admin Assignment Readiness', type: DNA_ROUTE_TYPES.ADMIN_ASSIGNMENT_READINESS },
  { path: `${DNA_APP_BASE_PATH}/admin/order-linkage`, label: 'DNA Admin Order Linkage', type: DNA_ROUTE_TYPES.ADMIN_ORDER_LINKAGE },
  { path: `${DNA_APP_BASE_PATH}/admin/household-readiness`, label: 'DNA Admin Household Readiness', type: DNA_ROUTE_TYPES.ADMIN_HOUSEHOLD_READINESS },
  { path: `${DNA_APP_BASE_PATH}/admin/premium-access-testing`, label: 'DNA Admin Premium Access Testing', type: DNA_ROUTE_TYPES.ADMIN_PREMIUM_ACCESS_TESTING },
];
